// packages/web/src/api/day-breaks/mutations.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { dayBreaksUpdate } from "../generated/sdk.gen.ts";
import type { DayBreaksUpdateData } from "../generated/types.gen.ts";

type UpdateBody = NonNullable<DayBreaksUpdateData["body"]>;

export function useUpdateDayBreak() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (vars: { userId: string; date: string; body: UpdateBody }) => {
      const { data, error } = await dayBreaksUpdate({
        path: { userId: vars.userId, date: vars.date },
        body: vars.body,
      });
      if (error) throw error;
      return data;
    },
    // admin-week joins day_breaks → invalidating hours-entries refetches the joined view
    onSuccess: () => qc.invalidateQueries({ queryKey: ["hours-entries"] }),
  });
}
